import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LyRippleModule } from 'alyle-ui/ripple-minimal';
import { LyHeaderPagination } from './header-pagination.component';
var LyHeaderPaginationModule = /** @class */ (function () {
    function LyHeaderPaginationModule() {
    }
    LyHeaderPaginationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, LyRippleModule],
                    exports: [LyHeaderPagination],
                    declarations: [LyHeaderPagination]
                },] },
    ];
    /** @nocollapse */
    LyHeaderPaginationModule.ctorParameters = function () { return []; };
    return LyHeaderPaginationModule;
}());
export { LyHeaderPaginationModule };
//# sourceMappingURL=header-pagination.module.js.map